import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContracteProgramari } from './contracte-programari.component';
import { MaterialModule } from 'src/app/material.module';
import { DataTablesModule } from 'angular-datatables';
import { ContracteProgramariDetaliiComponent } from './contracte-programari-detalii/contracte-programari-detalii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubsemnatComponent } from './contracte-programari-detalii/subsemnat/subsemnat.component';
import { DocumenteComponent } from './contracte-programari-detalii/documente/documente.component';
import { ViewDocumentComponent } from './contracte-programari-detalii/documente/view-document/view-document.component';
import { MesagerieComponent } from './contracte-programari-detalii/mesagerie/mesagerie.component';
import { IstoricComponent } from './contracte-programari-detalii/istoric/istoric.component';


@NgModule({
    declarations: [
        ContracteProgramari,
        ContracteProgramariDetaliiComponent,
        SubsemnatComponent,
        DocumenteComponent,
        ViewDocumentComponent,
        MesagerieComponent,
        IstoricComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        DataTablesModule,
    ],
    exports: [
        ContracteProgramari,
        DocumenteComponent,
        ViewDocumentComponent
    ],
})
export class ContracteProgramariModule { }
